import React from 'react';
import * as Fa6Icons from 'react-icons/fa6';
import SafeIcon from '../common/SafeIcon';

const Header = ({ darkMode, toggleDarkMode, openHelp }) => {
  const { FaMoneyCheckDollar, FaMoon, FaSun, FaCircleInfo } = Fa6Icons;

  return (
    <header className="bg-white/70 dark:bg-neutral-800/70 shadow-md backdrop-blur-lg sticky top-0 z-50 border-b border-gray-200 dark:border-neutral-700">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="relative mr-3">
              <div className="w-11 h-11 flex items-center justify-center rounded-xl shadow-md bg-gradient-to-br from-primary-400 to-secondary-500 text-white">
                <SafeIcon icon={FaMoneyCheckDollar} className="text-xl" />
              </div>
            </div>
            <div>
              <div className="flex items-baseline gap-2">
                <h1 className="text-xl font-bold text-gray-900 dark:text-white tracking-tight">
                  <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-indigo-600 dark:from-blue-400 dark:to-indigo-300">
                    Cheque Fill
                  </span>
                </h1>
                <span className="hidden lg:block text-[10px] font-medium text-gray-400 dark:text-neutral-500 border-l border-gray-300 dark:border-neutral-700 pl-2">
                  專業支票寫法工具
                </span>
              </div>
              <p className="text-[10px] font-bold tracking-widest text-gray-400 dark:text-gray-500 uppercase">
                by Homy Tech
              </p>
            </div>
          </div>

          <div className="flex items-center space-x-2 md:space-x-3">
            <button 
              onClick={toggleDarkMode} 
              className="p-2.5 rounded-lg bg-gray-100 dark:bg-neutral-700 text-gray-500 dark:text-gray-400 border border-gray-200 dark:border-neutral-700 hover:bg-gray-200 dark:hover:bg-neutral-600 transition-all"
              aria-label="Toggle Dark Mode"
            >
              <SafeIcon icon={darkMode ? FaSun : FaMoon} />
            </button>
            <button 
              onClick={openHelp}
              className="flex items-center px-3 md:px-4 py-2 text-sm rounded-lg bg-primary-50 dark:bg-primary-900/20 text-primary-600 dark:text-primary-400 border border-primary-200 dark:border-primary-800/50 hover:bg-primary-100 dark:hover:bg-primary-900/30 transition-all"
            >
              <SafeIcon icon={FaCircleInfo} className="mr-2" />
              <span className="hidden sm:inline font-bold">支票寫法指南</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;